import { render, staticRenderFns } from "./PluginsPage.vue?vue&type=template&id=044bea3a&scoped=true"
import script from "./PluginsPage.vue?vue&type=script&lang=ts"
export * from "./PluginsPage.vue?vue&type=script&lang=ts"
import style0 from "./PluginsPage.vue?vue&type=style&index=0&id=044bea3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bea3a",
  null
  
)

export default component.exports